import JSONViewRenderer from '../customRendererForColumns/JSONViewRenderer';
import { convertTimeToTimeZoneForDisplay } from '../../../helpers/commonHelper';

export const CONFIGURATION_AUDIT_HISTORY_COLUMN_CONFIG = [
  {
    field: 'action',
    headerName: 'Action',
    sortable: true,
    filter: true,
    flex: 1
  },
  {
    field: 'new_value',
    headerName: 'Updated Value',
    flex: 2,
    wrapText: true,
    autoHeight: true,
    cellRenderer: JSONViewRenderer
  },
  {
    field: 'old_value',
    headerName: 'Previous Value',
    flex: 2,
    wrapText: true,
    autoHeight: true,
    cellRenderer: JSONViewRenderer
  },
  {
    field: 'action_performed_date',
    headerName: 'Action Performed Date',
    sortable: true,
    sort: 'desc',
    flex: 1,
    cellRenderer: (params: any) => {
      return convertTimeToTimeZoneForDisplay(params?.value);
    }
  },
  {
    field: 'action_taken_by',
    headerName: 'Action Taken By',
    sortable: true,
    flex: 1
  }
];
